module.exports = __webpack_public_path__ + "img/manajemen_log.b411ddfb.svg";